// @flow
import { AxiosError } from "axios";

/**
 * Returns the error response from the API if set or and empty object
 *
 * @param error
 */
const getRequestErrorData = (error: AxiosError): string => {
  return error?.response?.data || {};
};

export default getRequestErrorData;
